import { RouterStateSnapshot } from '@angular/router';
import { RouterStateUrl } from './state/router.reducer';

export class RouterUtils {
  static extractActivatedRouterData(routerState: RouterStateSnapshot): RouterStateUrl {
    let route = routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    return {
      url,
      params,
      queryParams,
      segments: url
        .split('?')[0]
        .split('/')
        .slice(1),
    };
  }
}
